import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { businessInfo } from '../mockData';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/booking', label: 'Book Now' },
    { path: '/contact', label: 'Request Quote' }
  ];

  return (
    <header className="header-main">
      {/* Top bar with contact info */}
      <div className="header-topbar">
        <div className="container">
          <div className="topbar-content">
            <div className="topbar-left">
              <a href={`tel:${businessInfo.phone}`} className="topbar-link">
                <Phone size={16} />
                <span>{businessInfo.phoneFormatted}</span>
              </a>
              <a href={`mailto:${businessInfo.emails.service}`} className="topbar-link">
                <Mail size={16} />
                <span>{businessInfo.emails.service}</span>
              </a>
            </div>
            <div className="topbar-right">
              <span className="service-areas">
                Serving {businessInfo.serviceAreas.join(' • ')}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="header-navbar">
        <div className="container">
          <div className="navbar-content">
            <Link to="/" className="logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_premium-auto-care-24/artifacts/isyscnmq_logo.JPG" 
                alt="Prime Auto Logix Logo" 
                className="logo-image"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="nav-desktop">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* CTA Button */}
            <Link 
              to="/booking"
              className="btn-primary book-now-btn"
            >
              Book Appointment
            </Link>

            {/* Mobile menu toggle */}
            <button
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="nav-mobile">
          <div className="container">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link-mobile ${isActive(link.path) ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <a 
              href={`tel:${businessInfo.phone}`}
              className="btn-primary book-now-mobile"
            >
              Book Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
